import type { AppButtonProps } from "../../AppButton/next";

import {
  renderButton_unstable,
  useButtonStyles_unstable,
} from "@fluentui/react-components";
import * as React from "react";
import { useAppSplitButtonPrimaryButton } from "./useAppSplitButtonPrimaryButton";
import { AppTooltipContainer } from "@1js/acui-tooltip";

export const AppSplitButtonPrimaryButton = React.memo(
  React.forwardRef<HTMLButtonElement, AppButtonProps>((props, ref) => {
    const state = useAppSplitButtonPrimaryButton(props, ref);

    useButtonStyles_unstable(state);

    return (
      <AppTooltipContainer {...props}>
        {renderButton_unstable(state)}
      </AppTooltipContainer>
    );
  })
);

AppSplitButtonPrimaryButton.displayName = "next/AppSplitButtonPrimaryButton";
